<template>
    <div class="introduction">
        <h2 class="title">中心简介</h2>
        <ul class="icon-list flex-align-between">
            <li class="icon-item" v-for="(item,index) in iconList" :key="index">
                <img :src="item.icon" alt="" class="icon">
                <p class="icon-name">{{item.name}}</p>
            </li>
        </ul>
        <div class="inner flex-layout">
            <div class="img-warp">
                <img src="../../assets/general/image-5.png" alt="" class="left-img">
            </div>
            <div class="text">
                <p class="section">
                    为贯彻落实中共中央、国务院印发《中国教育现代化2035》精神，全面贯彻党的教育方针，深化教育体制机制改革，为进一步充分发挥首都师范大学在基础教育和教师教育领域的教科研优势和影响力，秉承首都师范大学以高水平学科支撑教师教育特色建设、培养新时代卓越教师为目标，以服务国家教育发展战略为指引，围绕首都师大“攀登精神”与践行“攀登计划”，满足全国各地对优质基础教育资源的需求，提升基础教育办学质量，促进教育资源均衡化发展，在首都师范大学对外合作办公室和教师发展中心的指导下，秉持首都师范大学“为师为学
                    求实求新”的校训，将教育部提出的“服务学生学习、服务教师备课和教学、服务学校管理、服务教育研究，以及未来服务教育改革这五大功能”，作为首都师范大学“双优云桥”教育服务的工作重心，成立首都师范大学“双优云桥”教育服务中心。
                </p>
                <p class="section">
                    为贯彻落实中共中央、国务院印发《中国教育现代化2035》精神，全面贯彻党的教育方针，深化教育体制机制改革，为进一步充分发挥首都师范大学在基础教育和教师教育领域的教科研优势和影响力，秉承首都师范大学以高水平学科支撑教师教育特色建设、培养新时代卓越教师为目标，以服务国家教育发展战略为指引，围绕首都师大“攀登精神”与践行“攀登计划”，满足全国各地对优质基础教育资源的需求，提升基础教育办学质量，促进教育资源均衡化发展，在首都师范大学对外合作办公室和教师发展中心的指导下，秉持首都师范大学“为师为学
                    求实求新”的校训，将教育部提出的“服务学生学习、服务教师备课和教学、服务学校管理、服务教育研究，以及未来服务教育改革这五大功能”，作为首都师范大学“双优云桥”教育服务的工作重心，成立首都师范大学“双优云桥”教育服务中心。
                </p>
                <p class="section">
                    为贯彻落实中共中央、国务院印发《中国教育现代化2035》精神，全面贯彻党的教育方针，深化教育体制机制改革，为进一步充分发挥首都师范大学在基础教育和教师教育领域的教科研优势和影响力，秉承首都师范大学以高水平学科支撑教师教育特色建设、培养新时代卓越教师为目标，以服务国家教育发展战略为指引，围绕首都师大“攀登精神”与践行“攀登计划”，满足全国各地对优质基础教育资源的需求，提升基础教育办学质量，促进教育资源均衡化发展，在首都师范大学对外合作办公室和教师发展中心的指导下，秉持首都师范大学“为师为学
                    求实求新”的校训，将教育部提出的“服务学生学习、服务教师备课和教学、服务学校管理、服务教育研究，以及未来服务教育改革这五大功能”，作为首都师范大学“双优云桥”教育服务的工作重心，成立首都师范大学“双优云桥”教育服务中心。
                </p>

            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                iconList: [{
                        icon: require("../../assets/general/icon-1.png"),
                        name: '服务学生学习'
                    },
                    {
                        icon: require("../../assets/general/icon-2.png"),
                        name: '服务教育研究'
                    },
                    {
                        icon: require("../../assets/general/icon-3.png"),
                        name: '服务学校管理'
                    },
                    {
                        icon: require("../../assets/general/icon-4.png"),
                        name: '服务教师备课和教学'
                    }, {
                        icon: require("../../assets/general/icon-5.png"),
                        name: '服务教育改革'
                    }
                ]
            }
        }
    }
</script>

<style lang="less" scoped>
    .introduction {
        padding: 0 5.2% 70% !important;
        // background-image: url("../../assets/business/bg.png");
        // background-repeat: no-repeat;
        // background-position: bottom;

        .title {
            font-size: 20px;
            padding: 3.3% 0 4.1%;
            text-align: center;
        }

        .icon-list {
            padding: 0 1.2% 5.7%;

            .icon-item {
                font-size: 15px;
                text-align: center;
                width: calc(100% / 5);
            }

            .icon {
                width: 38.2%
            }

            .icon-name {
                margin-top: 15.7%;
            }
        }

        .img-warp {
            width: 42.3%;
            min-width: 420px;
            max-width: 719px;
            margin-right: 2.5%;
            align-self: flex-start;

            .left-img {
                width: 100%;
            }
        }

        .text {
            padding-top: 4.8%;
            font-size: 12px;
            line-height: 2;
            font-weight: 300;
            max-width: 55%;

            .section {
                text-indent: 2em;
                margin-bottom: 2.8%;
            }
        }


        @media screen and (min-width:1250px) {
            .title {
                font-size: 26px;
            }

            .icon-list {
                .icon-item {
                    font-size: 20px;
                }
            }

            .text {
                font-size: 15px;
            }
        }

        @media screen and (min-width:1680px) {
            .title {
                font-size: 36px;
            }

            .icon-list {
                .icon-item {
                    font-size: 28px;
                }
            }

            .text {
                font-size: 20px;
            }
        }


    }
</style>